/**
 * P7 — every "this friend can't take a duel right now" refusal shows ONE neutral message.
 *
 * The backend answers a refused invite or challenge with a bare-string error key (see
 * `resolveBackendMessageKey`). A friend who hides their status is refused as `inviteeNotAvailable`; the
 * other availability codes stay as they are for visible friends. Showing the same words for all of them
 * keeps a hidden friend's state unreadable from the screen, and still tells everyone else why the
 * invite didn't go through. Anything else keeps the caller's generic fallback.
 */
const AVAILABILITY_REFUSAL_CODE_SET = new Set([
  "inviteeNotAvailable",
  "inviteeNotOnline",
  "inviteeBusySolving",
  "inviteeBusyInExam",
  "inviteeAlreadyInDuel",
]);

export const resolveDuelInviteRefusalKey = (err: unknown, fallbackMessageKey: string): string => {
  const body = (err as any)?.response?.data;
  return typeof body === "string" && AVAILABILITY_REFUSAL_CODE_SET.has(body)
    ? "friend_not_available_right_now"
    : fallbackMessageKey;
};
